import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import BASE_URL from "../../config/config";
import OTPLogin from "./OTPLogin";
import Captcha from "./Captcha";
import aiLogo from "../../assets/ai-logo.png";
import "../../css/loginForm.css";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth(); // ✅ دریافت user از context
  const [csrfToken, setCsrfToken] = useState("");
  const [loginMethod, setLoginMethod] = useState("username");
  const [captchaVerified, setCaptchaVerified] = useState(false);

  // ✅ ریدایرکت اگر کاربر قبلاً لاگین کرده باشد
  useEffect(() => {
    if (user) {
      // اگر کاربر ادمین بود، به /admin، وگرنه به /dashboard
      if (user.role === "admin") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [user, navigate]);


  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          credentials: "include",
        });
        const data = await response.json();
        setCsrfToken(data.csrfToken);
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!captchaVerified) {
      setMessage("لطفاً کد امنیتی را تأیید کنید");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ username, password }),
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("ورود موفقیت‌آمیز بود!");
        const token = data.token;
        localStorage.setItem("token", token);
        const userData = data.userInfo;
        login(userData);

        // بعد از لاگین موفق، به داشبورد یا ادمین برو
        if (userData.role === "admin") {
          navigate("/admin");
        } else {
          navigate("/dashboard");
        }
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage("خطا در برقراری ارتباط با سرور. لطفاً بعداً تلاش کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleLoginMethod = (method) => {
    setLoginMethod(method);
    setMessage("");
  };

  if (user) {
    return null; // یا یک اسپینر کوچک در حین ریدایرکت
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="login-container">
        {/* Left Side */}
        {/* <div className="login-left">
          <h1 className="login-title">سلام، دوست خوبم</h1>
          <p className="login-subtitle">
            وارد حساب کاربری خود شوید و با ما به کشف جهان بپردازید!
          </p>
        </div> */}

        {/* Right Side */}
        <div className="login-right">
          <div className="logo mb-6">
            <img src={aiLogo} alt="لوگو" className="w-16 h-16 mx-auto mb-2" />
            <p className="text-center text-dark font-bold text-lg">هوش جدید </p>
          </div>

          <h2 className="login-title text-center mb-6">ورود</h2>

          {/* Tabs */}
          <div className="tabs">
            <button
              className={`tab ${loginMethod === "username" ? "active" : ""}`}
              onClick={() => toggleLoginMethod("username")}
            >
              ورود با نام کاربری
            </button>
            <button
              className={`tab ${loginMethod === "mobile" ? "active" : ""}`}
              onClick={() => toggleLoginMethod("mobile")}
            >
              ورود با موبایل
            </button>
          </div>

          {/* فرم ورود با نام کاربری */}
          {loginMethod === "username" ? (
            <form onSubmit={handleSubmit} className=" space-y-4">
              <div className="input-group">
                <input
                  type="text"
                  placeholder="نام کاربری"
                  className="form-input"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="input-group">
                <input
                  type="password"
                  placeholder="رمز عبور"
                  className="form-input"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <Captcha
                onVerify={(isVerified) => setCaptchaVerified(isVerified)}
                onExpire={() => setCaptchaVerified(false)}
                timeout={120000}
                regenerateOnError={true}
              />

              {message && (
                <p
                  className={
                    message.includes("موفقیت")
                      ? "success-message text-center py-2"
                      : "error-message text-center py-2"
                  }
                >
                  {message}
                </p>
              )}

              <div className="text-center text-sm text-gray-600 mt-4">
                <p>
                  ثبت نام نکرده‌اید؟{" "}
                  <Link to="/signup" className="text-primary hover:underline">
                    ثبت نام
                  </Link>
                </p>
                <p className="mt-1">
                  رمز عبور خود را فراموش کرده‌اید؟{" "}
                  <Link to="/forgot-password" className="text-primary hover:underline">
                    فراموشی رمز عبور
                  </Link>
                </p>
              </div>

              <button
                type="submit"
                className="w-full btn-primary mt-4 py-3 rounded-xl font-bold"
                disabled={isLoading || !captchaVerified}
              >
                {isLoading ? "در حال ورود..." : "ورود"}
              </button>
              <button
                className="extra-button mt-6"
                onClick={() => navigate("/signup")}
              >
                🆕 عضویت در هوش جدید
              </button>
            </form>
          ) : (
            <OTPLogin />
          )}

          {/* دکمه عضویت زیر فرم */}

        </div>
      </div>
    </div>
  );
}